const SubAbasDenominacoesGenericas = (id: string) => [
  {
    label: 'Dados Gerais',
    rota: `/secsaude/produtosdaf/denominacoes/ficha/${id}/dadosgerais`,
  },
];

export default SubAbasDenominacoesGenericas;
